import styled from 'styled-components'

export const InputText = styled.input`
  margin: 0;
  inline-size: 100%;
`
